module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-11@3x__ea00131df4d707db2ffc7577d2f5593c.png";